import { render, staticRenderFns } from "./BugReportButton.vue?vue&type=template&id=653ac3ca&scoped=true"
import script from "./BugReportButton.vue?vue&type=script&lang=js"
export * from "./BugReportButton.vue?vue&type=script&lang=js"
import style0 from "./BugReportButton.vue?vue&type=style&index=0&id=653ac3ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ac3ca",
  null
  
)

export default component.exports